export default function normalizeSearch(value: string) {
    return value.trim().replace(/\s{2,}/g, ' ');
}
